/**
 * Centralized logging utility
 * Replaces console.log with proper logging levels
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Log debug information (only in development)
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Log informational messages
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Log warnings
   */
  warn: (...args: any[]) => {
    console.warn('[WARN]', ...args);
  },

  /**
   * Log errors
   */
  error: (...args: any[]) => {
    console.error('[ERROR]', ...args);
  },

  /**
   * Log AI-related debug info (only in development)
   */
  ai: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[AI]', ...args);
    }
  },

  /**
   * Structured lifecycle log for production hardening (audio, mic, load, index, recovery).
   * Explains WHY a fallback or action happened.
   */
  lifecycle: (feature: string, event: string, detail?: Record<string, unknown>) => {
    const payload = { feature, event, ...detail, ts: Date.now() };
    if (isDevelopment) {
      console.log('[LIFECYCLE]', payload);
    }
  },
};


